//Check if Filters have loaded.
var checkFilters = setInterval(function(){
  if(document.querySelectorAll('.refinementButton-sort button, .refinementButton-sort label, .refinementButton-boolean').length){
    // enableAnalyticsForFilters();
    clearInterval(checkFilters);
  }
}, 200);

function enableAnalyticsForFilters(){

  //Check if element is Refinement List Label that has been selected.
  document.querySelectorAll('.refinementButton-sort label input').forEach(function(element) {
    element.addEventListener('change', function() {
      //Check if element is Refinement List Label
      if(element.checked === true){
        let label = element.closest('.refinementButton-sort').querySelector('button[aria-expanded="true"] > span').innerText;
        let value = element.closest('label').querySelector('input + span').innerText;
        dataLayer.push({'event': 'CollectionFilters', 'Collection_Category': 'Collection_Filter', 'Collection_Action': 'Sorting', 'Collection_Label': label, 'Collection_Value': value});
      }
    });
  });

  document.querySelectorAll('.refinementButton-sort button, .refinementButton-sort label, .refinementButton-boolean').forEach(function(element) {
    
    element.addEventListener('click', function() {

      //Check if element is Refinement List Button
      if( element.ariaExpanded ){
        if( element.ariaExpanded == 'false' ){
          dataLayer.push({'event': 'CollectionFilters', 'Collection_Category': 'Collection_Filter', 'Collection_Action': 'Sorting', 'Collection_Label': element.innerText, 'Collection_Value': 'Opened'});
        }else if( element.ariaExpanded == 'true' ){
          dataLayer.push({'event': 'CollectionFilters', 'Collection_Category': 'Collection_Filter', 'Collection_Action': 'Sorting', 'Collection_Label': element.innerText, 'Collection_Value': 'Closed'});
        }
      }

      //Check if element is Refinement Boolean Button
      if( element.ariaPressed ){
        if( element.ariaPressed == 'false' ){
          dataLayer.push({'event': 'CollectionFilters', 'Collection_Category': 'Collection_Filter', 'Collection_Action': 'Boolean', 'Collection_Label': element.innerText, 'Collection_Value': 'true'});
        }else if( element.ariaPressed == 'true' ){
          dataLayer.push({'event': 'CollectionFilters', 'Collection_Category': 'Collection_Filter', 'Collection_Action': 'Boolean', 'Collection_Label': element.innerText, 'Collection_Value': 'false'});
        }
      }
    });
  });
}